import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import qs from 'qs';
import VueCookie from 'vue-cookie';
// import router from '../../router'

Vue.use(VueCookie);
Vue.use(Vuex)
Vue.use(VueAxios, axios)
Vue.prototype.qs = qs


export default {
    state: {
        errorData: {
            errorMsg: "",
            errorVisible: false,
            errorType: {
                'negativ': false,
                'positiv': false,
                'neutral': false
            },
        },
        failedAttempts: 0,
        lastFailedAttemptTime: null,
        maxAttempts: 5,
        blockedUntil: null,
    },
    mutations: {
        assignErrorMsg: (state,error) => {
            state.errorData.errorMsg = error.msg;
            state.errorData.errorVisible = true;
            state.errorData.errorType.negativ = false;
            state.errorData.errorType.positiv = false;
            state.errorData.errorType.neutral = false;
            switch(error.type) {
                case "negativ": state.errorData.errorType.negativ = true; break;
                case "positiv": state.errorData.errorType.positiv = true; break;
                case "neutral": state.errorData.errorType.neutral = true; break;
            }
        },
        assignErrorVisible: (state,errorVisible) => {
            state.errorData.errorVisible = errorVisible;
        },
        incrementFailedAttempts(state) {
            state.failedAttempts++;
            localStorage.setItem('failedAttempts', state.failedAttempts);
        },
        initializeFailedAttempts(state) {
            const failedAttempts = localStorage.getItem('failedAttempts');
            if (failedAttempts) {
                state.failedAttempts = parseInt(failedAttempts);
            }
        },
        resetFailedAttempts(state) {
            state.failedAttempts = 0;
            state.lastFailedAttemptTime = null;
        },
        updateLastFailedAttemptTime(state, time) {
            state.lastFailedAttemptTime = time;
        },
        updateBlockedUntil(state, blockedUntil) {
            state.blockedUntil = blockedUntil;
            localStorage.setItem('blockedUntil', blockedUntil); // Save blockedUntil timestamp in localStorage
        },
        initializeBlockedUntil(state) {
            const blockedUntil = localStorage.getItem('blockedUntil');
            if (blockedUntil && Date.now() < parseInt(blockedUntil)) {
                state.blockedUntil = parseInt(blockedUntil);
            }
        },
    },
    getters: {

    },
    actions: {
        changeErrorMsg: ({commit}, error) => {
            commit("assignErrorMsg",error)
            window.setTimeout(function() {
                commit("assignErrorVisible",false)
            }, 30000);
        },
        toggleErrorVisible: ({commit}, errorVisible) => {
            commit("assignErrorVisible",errorVisible)
            window.setTimeout(function() {
                commit("assignErrorVisible",false)
            }, 30000);
        },
        incrementFailedAttempts({ commit }) {
            commit('incrementFailedAttempts');
        },
        resetFailedAttempts({ commit }) {
            commit('resetFailedAttempts');
        },
        updateLastFailedAttemptTime({ commit }, time) {
            commit('updateLastFailedAttemptTime', time);
        },

    },
}
